import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";

export const today = () => new Date().toISOString().slice(0, 10);
export const monthStart = () => today().slice(0, 8) + "01";

export function FormDialog({ open, onClose, title, desc, children, onSave, saveLabel = "Save", disabled, testId, wide }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className={`max-h-[90vh] overflow-y-auto ${wide ? "max-w-4xl" : "max-w-lg"}`} data-testid={testId}>
        <DialogHeader><DialogTitle>{title}</DialogTitle>{desc && <DialogDescription>{desc}</DialogDescription>}</DialogHeader>
        {children}
        <DialogFooter><Button data-testid={`${testId}-save`} disabled={disabled} onClick={onSave} className="bg-[#13294B] hover:bg-[#1c3a66]">{saveLabel}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function AccountSelect({ accounts, value, onChange, types, subtypes, testId, placeholder = "Select account" }) {
  const list = accounts.filter((a) => (!types || types.includes(a.type)) && (!subtypes || subtypes.includes(a.subtype)));
  return (
    <select data-testid={testId} className="po-select" value={value || ""} onChange={(e) => onChange(e.target.value)}>
      <option value="">{placeholder}</option>
      {list.map((a) => <option key={a.code} value={a.code}>{a.code} · {a.name}</option>)}
    </select>
  );
}

export function PeriodFilter({ p, setP, testId = "period" }) {
  return (
    <div className="flex flex-wrap items-end gap-2">
      <Field label="From"><Input type="date" data-testid={`${testId}-from`} value={p.frm} onChange={(e) => setP({ ...p, frm: e.target.value })} /></Field>
      <Field label="To"><Input type="date" data-testid={`${testId}-to`} value={p.to} onChange={(e) => setP({ ...p, to: e.target.value })} /></Field>
    </div>
  );
}

export const qs = (o) => new URLSearchParams(Object.entries(o).filter(([, v]) => v)).toString();
